import { render, staticRenderFns } from "./zbResultNotice.vue?vue&type=template&id=344c9762&scoped=true"
import script from "./zbResultNotice.vue?vue&type=script&lang=js"
export * from "./zbResultNotice.vue?vue&type=script&lang=js"
import style0 from "./zbResultNotice.vue?vue&type=style&index=0&id=344c9762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344c9762",
  null
  
)

export default component.exports